
const ACTIONS = {
    CALL_API: 'call-api',
    SUCCESS: 'success',
    ERROR: 'error',

    SET_INITIAL_DATA: 'set-data',
    PHONE_CHANGE: 'phone-change',
    PHONE_SET_ERRORS: 'phone-set-errors',
    PHONE_REMOVE_ERRORS: 'phone-remove-errors'
};

const phoneInputDataReducer = (state, action) => {
    //console.log("phone input dispatch triggered", state, action);

    switch (action.type) {
        case ACTIONS.SET_INITIAL_DATA: {
            return {
                ...state,
                value: action.value,
                validation:{
                    ...state.validation,
                    isInvalid: false,
                    errors: [],
                    isValid: false,
                    successMsgs: []
                }
            };
        }
        case ACTIONS.PHONE_CHANGE: {
            //console.log("state-PHONECHANGE");
            //console.log(state);
            
            return {
                ...state,
                value: action.value,
                validation:{
                    ...state.validation,
                    isInvalid: false,
                    errors: [],
                    isValid: false,
                    successMsgs: []
                }
            };
        }
        case ACTIONS.PHONE_SET_ERRORS: {
            //console.log("state");
            //console.log(state);

            
            return {
                ...state,
                validation:{
                    ...state.validation,
                    isInvalid: action.errors != null && action.errors.length > 0 ? true : false,
                    errors: action.errors
                }
            };
        }
        case ACTIONS.PHONE_REMOVE_ERRORS: {
            
            return {
                ...state,
                validation:{
                    ...state.validation,
                    isInvalid: false,
                    errors: []
                }
            };
        }
    }
}



export {ACTIONS, phoneInputDataReducer};